import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

function DialogTool(props, ref) {  

    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogAnswer, setDialogAnswer] = React.useState(false);

    React.useImperativeHandle(
        ref,
        () => ({
            showDialog() {
                setOpenDialog(true)
            },
            closeDialog() {
                setOpenDialog(false)
            }        
         }),
      )

    
    
    const handleCloseDialog = () => {
        setOpenDialog(false)
    }
    
    const handleCloseDialogYes = () => {
        setDialogAnswer(true)
        setOpenDialog(false)
        props.onSelectYes()
    }
    
    const handleCloseDialogNo = () => {
        setDialogAnswer(false)
        setOpenDialog(false)
        props.onSelectNo()
    }

    const showDialog = () => {
        setOpenDialog(true)
    }

    const labelButtonYes = props.labelButtonYes ? props.labelButtonYes : "YES"
    const labelButtonNo = props.labelButtonNo ? props.labelButtonNo : "NO"
    
    
     
    return (
        <Dialog
            open={openDialog}
            keepMounted
            onClose={handleCloseDialog}
        >
        <DialogTitle id="alert-dialog-slide-title">{props.title}</DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
            {props.message}
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleCloseDialogYes} color="primary">{labelButtonYes}</Button>
        <Button onClick={handleCloseDialogNo} color="primary">{labelButtonNo}</Button>
            {props.children}
        </DialogActions>
    </Dialog>
    )
}

export default React.forwardRef(DialogTool)



// WEBPACK FOOTER //
// ./src/components/DialogTool.js